import React from "react";
import { Link } from "react-router-dom";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";

const facts = [
    ["Nombre", "EMMPIEZA"],
    ["Razón social", "EMMPIEZA COMUNICACIONES S.A.S"],
    ["Constitución", "2019"],
    ["Base", "Colombia"],
    ["Fundador y CEO", "Raúl Andrés Fajardo Murillo"],
    ["Posicionamiento", "IA, ciberseguridad y software para operaciones críticas"],
    ["Especialización", "Aviación y seguridad operacional"],
    ["Contacto", "emmpieza@gmail.com"],
];

export default function About() {
    return (
        <Layouts>
            <header><NavbarComponent /></header>
            <main className="min-h-screen bg-em-bg pb-[calc(7rem+var(--em-footer-h))] pt-32 text-em-text sm:pt-36 md:pt-40">
                <div className="mx-auto max-w-5xl px-5 md:px-8">
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-em-accent">Identidad y experiencia</p>
                    <h1 className="mt-4 max-w-4xl text-4xl font-black tracking-tight md:text-6xl">
                        Tecnología con criterio técnico y conocimiento operacional
                    </h1>
                    <p className="mt-7 max-w-3xl text-lg leading-8 text-em-soft md:text-xl">
                        EMMPIEZA COMUNICACIONES S.A.S es una empresa tecnológica colombiana de inteligencia artificial,
                        ciberseguridad y software para operaciones críticas, especializada en aviación y seguridad operacional.
                    </p>

                    <section className="mt-14 grid gap-8 md:grid-cols-[1.1fr_0.9fr]">
                        <div className="rounded-3xl border border-em-text/10 bg-em-card p-7 md:p-9">
                            <h2 className="text-2xl font-extrabold">Qué nos diferencia</h2>
                            <p className="mt-4 leading-7 text-em-soft">
                                El equipo reúne desarrollo full stack, seguridad ofensiva, análisis de datos,
                                formación en inteligencia artificial y dos décadas de experiencia del fundador en
                                la Fuerza Aeroespacial Colombiana. Esa combinación permite entender tanto la
                                tecnología como el contexto donde debe funcionar.
                            </p>
                            <p className="mt-4 leading-7 text-em-soft">
                                Nuestra actividad es verificable mediante aplicaciones publicadas, plataformas web,
                                herramientas de ciberseguridad y contenidos especializados.
                            </p>
                        </div>
                        <dl className="overflow-hidden rounded-3xl border border-em-text/10 bg-em-bg">
                            {facts.map(([term, detail]) => (
                                <div key={term} className="border-b border-em-text/10 p-5 last:border-0">
                                    <dt className="text-xs font-bold uppercase tracking-wider text-em-muted">{term}</dt>
                                    <dd className="mt-1 font-semibold text-em-text">{detail}</dd>
                                </div>
                            ))}
                            <div className="p-5">
                                <dt className="text-xs font-bold uppercase tracking-wider text-em-muted">Verificación empresarial</dt>
                                <dd className="mt-2">
                                    <a
                                        className="font-semibold text-em-accent hover:text-em-accent2"
                                        href="https://bibliotecadigital.ccb.org.co/server/api/core/bitstreams/88634c24-59aa-45fe-84c6-8414610c21d2/content"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Boletín oficial de la Cámara de Comercio de Bogotá ↗
                                    </a>
                                </dd>
                            </div>
                        </dl>
                    </section>

                    <section className="mt-14">
                        <h2 className="text-3xl font-black">Áreas de trabajo</h2>
                        <div className="mt-7 grid gap-4 sm:grid-cols-2">
                            {[
                                ["Inteligencia artificial", "/servicios/inteligencia-artificial"],
                                ["Software web y móvil", "/servicios/software-y-aplicaciones"],
                                ["Ciberseguridad", "/servicios/ciberseguridad"],
                                ["IA para aviación", "/ia-aviacion-seguridad-operacional"],
                            ].map(([label, to]) => (
                                <Link key={to} to={to} className="rounded-2xl border border-em-text/10 bg-em-card p-6 text-lg font-bold transition hover:-translate-y-1 hover:border-em-accent/40 hover:text-em-accent">
                                    {label} <span aria-hidden>→</span>
                                </Link>
                            ))}
                        </div>
                    </section>
                </div>
            </main>
            <Footer />
        </Layouts>
    );
}
